/** Platform label used for user-defined custom sizes. */
export const CUSTOM_PLATFORM_LABEL = 'Custom';

/** A single resize target format, as understood by the smart-resize agent flow. */
export type SmartResizeFormat = {
  format: string;
  formatId: string;
  platform: string;
  /** Set for saved sizes, whose name the chat message shows instead of the `format` label. */
  savedSizeName?: string;
};

/** Payload handed to a custom `onGenerate` override when the user submits the dropdown. */
export type SmartResizeGenerateParams = {
  formats: SmartResizeFormat[];
};

export type SmartResizeDropdownProps = {
  /** Optional node when an `onGenerate` override is supplied
   * (e.g. group resize resolves its target node lazily by flattening first).
   */
  nodeId?: string;
  /**
   * Overrides the default single-node submit behavior. When provided, the
   * dropdown computes the selected formats and delegates the actual resize to
   * this callback instead of sending a smart-resize message for `nodeId`.
   */
  onGenerate?: (params: SmartResizeGenerateParams) => Promise<void> | void;
  onOpenChange: (open: boolean) => void;
};
